<template>
    <div class="row justify-content-center">
        <div class="col-sm-12">
            <div class="row programme">
                <div class="col-sm-8">
                    <h4 class="card-title text-left" >{{ title }} - <small>{{ department }}</small></h4>
                    <p class="card-text">{{ description }}</p>
                    <p class="card-text" v-if="paper">More details can be found here: <router-link tag="a" :to="`/CBCS/papers/preview/${paper}`">Click Here</router-link></p>
                    <div class="row">
                        <div class="col-sm-4">
                            <p class="card-text">
                                <el-tooltip :content="`Price for registration is ${ (price > 0) ? price : 'free'}.`" :open-delay="100" placement="bottom">
                                    <n-button :type="`${ (price > 0) ? 'success' : 'default' }`" icon simple round size="sm">
                                        ₹
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip :content="`Authentication is ${ (login) ? 'required' : 'not required'}.`" :open-delay="100" placement="bottom">
                                    <n-button :type="`${ (login) ? 'success' : 'default' }`" icon simple round size="sm">
                                        <i class="now-ui-icons business_badge"></i>
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip :content="`Visibility is ${ (visible) ? 'true' : 'false'}.`" :open-delay="100" placement="bottom">
                                    <n-button :type="`${ (visible) ? 'success' : 'default' }`" icon simple round size="sm">
                                        <i class="now-ui-icons business_bulb-63"></i>
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip v-if="type" :content="`Type is ${type}.`" :open-delay="100" placement="bottom">
                                    <n-button :type="`${ (type == 'individual') ? 'success' : 'default' }`" icon simple round size="sm">
                                        <i v-if="type == 'individual'" class="now-ui-icons users_single-02"></i>
                                        <i  v-else class="fa fa-users"></i>
                                    </n-button>
                                </el-tooltip>
                                <el-tooltip v-if="multipleEntry" :content="`Multiple Entry is ${ (multipleEntry) ? 'allowed' : 'not'}.`" :open-delay="100" placement="bottom">
                                    <n-button :type="`${ (multipleEntry) ? 'success' : 'default' }`" icon simple round size="sm">
                                        <i v-if="type == 'individual'" class="now-ui-icons users_single-02"></i>
                                        <i  v-else class="fa fa-users"></i>
                                    </n-button>
                                </el-tooltip>
                            </p>
                            <span class="card-text bb-lines">
                                <p class="bb-line" v-if="seating"> <small>Max Registrations:</small> <span class="pull-right">{{ seating.max_seat }}</span> </p>
                                <p class="bb-line" v-if="permitted_enrollments"> <small>Permitted Enrollments:</small> <span class="pull-right">{{ permitted_enrollments }}</span> </p>
                                <p class="bb-line" v-if="max_teams"> <small>Max Teams:</small> <span class="pull-right">{{ max_teams }}</span> </p>
                                <p class="bb-line" v-if="min_participants"> <small>Min Participants:</small> <span class="pull-right">{{ min_participants }}</span> </p>
                                <p class="bb-line" v-if="max_participants"> <small>Max Participants:</small> <span class="pull-right">{{ max_participants }}</span> </p>
                            </span>
                        </div>
                        <div class="col-sm-8">
                            <p class="card-text" v-if="open_date && close_date">
                                <small>Registration Window:</small><br>{{ formattedDate(open_date) }} - {{ formattedDate(close_date) }}
                            </p>
                            <p class="card-text" v-if="start_date && end_date">
                                <small>Date & Time: </small><br>{{ formattedDate(start_date) }} - {{ formattedDate(end_date) }}
                            </p>
                            <p class="card-text" v-if="venue">
                                <small>Venue: </small><br>{{ venue }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-sm-4">
                    <div class="cover-img" v-if="image" :style="`background-image:url(${image})`"></div>
                </div>
                <div class="col-12">
                    <collapse>
                        <collapse-item :title="`Batches (${batches.length})`" name="batches" v-if="batches && batches.length > 0">
                            <span class="badge badge-default mr-2" v-for="(batch, index) in batches" :key="index">{{ batch }}</span>
                        </collapse-item>
                        <collapse-item :title="`Coordinators (${coordinators.length})`" name="coordinators" v-if="coordinators && coordinators.length > 0">
                            <div class="row">
                                <div class="col-sm-6" v-for="(coordinator, index) in coordinators" :key="index">
                                    <div class="card coordinator-card">
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-sm-3 text-center">
                                                    <img :src="getAvatar(coordinator)" alt="" class="">
                                                </div>
                                                <div class="col-sm-9">
                                                    <h6>{{ coordinator.designation }} {{ coordinator.name }} <br> <small>{{ coordinator.title }}</small></h6>
                                                    <a :href="`tel:${coordinator.phone}`">{{ coordinator.phone }}</a> <br/>
                                                    <a :href="`mailto:${coordinator.email}`">{{ coordinator.email }}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </collapse-item>
                        <collapse-item :title="`Form (${form.length})`" name="forms" v-if="(form && form.length > 0) || (pool && (this.batches.length < 1 && this.login))">
                            <DynamicForm 
                                :batches="batches"
                                :withSubmit="withSubmit" 
                                :price="price" 
                                :form="form"  
                                :action="null" 
                                :slug="null" 
                                :title="title" 
                                :max_teams="max_teams" 
                                :min_participants="min_participants" 
                                :max_participants="max_participants"
                                :participants_pool="participants_pool" 
                                @on-pool="gotParticipants"
                                :entity="entity"
                                :open_date="open_date">
                                    <template slot="header" class="text-center">
                                        <p class="card-text text-center" >Registration form for {{ title }}</p>
                                    </template>
                            </DynamicForm>
                        </collapse-item>
                    </collapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { DynamicForm, Tabs, TabPane, Collapse, CollapseItem } from "src/components";
import {Tooltip} from 'element-ui'

export default {
    name: 'PreviewForm',
    components: {
        DynamicForm,
        Tabs,
        TabPane,
        Collapse,
        CollapseItem,
        [Tooltip.name]: Tooltip,
    },
    props: {
        venue: String,
        entity: String,
        type: String,
        login: Boolean,
        visible: Boolean,
        pool: Boolean,
        multipleEntry: Boolean,
        title: String,
        description: String,
        price: [Number, String],
        department: String,
        image: String,
        batches: Array,
        form: Array,
        coordinators: Array,
        seating: {
            type: Object,
            default: function(){
                    return {max_seat: 0}
                }
        },
        permitted_enrollments: Number,
        open_date: [Date, String],
        close_date: [Date, String],
        start_date: [Date, String],
        end_date: [Date, String],
        max_teams: Number,
        min_participants: Number,
        max_participants: Number,
        participants_pool: Array,
        withSubmit: {
            type: Boolean,
            default: false
        },
        paper: {
            type: String,
            default: null
        }
    },
    methods: {
        formattedDate(cellValue, withTime = true){
            if(!cellValue)
                return '--';
            var d = new Date(cellValue);
            var options = (withTime) ? { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' } : { year: 'numeric', month: 'long', day: 'numeric' }
            return  d.toLocaleDateString('en-US', options); 
        },
        gotParticipants(pool){
            this.$emit('on-pool', Object.assign([], pool))
        },
        getAvatar(coordinator){
            return (coordinator.image) ? coordinator.image : `https://ui-avatars.com/api/?background=0D8ABC&color=FFF&bold=true&size=128&name=${coordinator.name}`
        }
    }
}
</script>

<style lang="scss">

.programme{
    .cover-img{
        height: 200px;
    }
    .card-title{
        margin-top: 0;
    }
}

.event{
    .cover-img{
        height: 100px;
    }
    .card-title{
        margin-top: 0;
    }
}

.cover-img{
    width: 100%;
    height: 100px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
}

.card-text .btn{
    margin-top: 0;
    margin-bottom: 0;
}

.side-text{
    margin-left: 5px;
}

p.bb-line{
    margin: 0;
    border-bottom: solid 1px #eee;
}

p.bb-line:last-child{
    border-bottom: solid 1px #fff;
}
.coordinator-card img{
    border-radius: 100%;
    width: auto;
    height: 80px;
}
</style>
